import React, { useContext } from 'react'
import classNames from 'classnames'
import { array, object, string } from 'prop-types'

import Grid from '../Grid'
import Card from '../Card'
import Surround from '../Surround'
import Inline from '../Inline'
import Tag from '../Tag'
import Title from '../Title'
import Container from '../Container'
import Advert from '../Advert'

import styles from './VideoGrid.module.scss'
import Column from '@/component/Structure/Column'
import { RowContext } from '@/component/Context/RowContext'

const VideoGrid = ({ articles, title, ctaUrl, advertProps, pageData }) => {
  const inverseRow = useContext(RowContext)
  if (!articles.length) return null
  const remainingArticles = articles.slice(1, 4)
  const imageRatio = 375 / 668

  return (
    <div className={classNames(styles.VideoGrid, inverseRow && styles.inverse)}>
      <Container center gutter size="wide">
        <div className={styles.Title}>
          <Title inverse ctaLabel="View all" ctaUrl={ctaUrl} title={title} />
        </div>
        <div className={styles.HeroCard}>
          <Card
            typeConfig={{
              title: { size: ['heading7', 'heading2'], themed: true },
              description: { size: 'body2' }
            }}
            inverse
            hasShade
            imageIcon="play"
            contentBorder={['top', 'bottom']}
            clickableFooter
            horizontal
            gridGutter="default"
            gridWidths={[3 / 5, 2 / 5]}
            headerComponents={() => {
              if (!articles[0].featured) return null
              return (
                <Tag themedFont background="white">
                  Featured
                </Tag>
              )
            }}
            footerComponents={() => {
              if (!articles[0].hashtags) return null
              return (
                <Inline gap="small">
                  {articles[0].hashtags.map((tag, i) => (
                    <Tag
                      key={i}
                      italic
                      uppercase
                      nofollow
                      background="grey"
                      href={`/search?q=${encodeURIComponent(tag)}`}
                    >{`#${tag}`}</Tag>
                  ))}
                </Inline>
              )
            }}
            {...{
              ...articles[0],
              description: articles[0].sell,
              sizes: [
                '(min-width: 1420px) 786px',
                '(min-width: 960px) calc(60vw - 32px - 80px)',
                'calc((100vw - 80px) * 0.5)'
              ],
              width: 786
            }}
            imageRatio={imageRatio}
          />
        </div>
        <Container flex center size="wide">
          <Column column={{ width: undefined, attributes: [] }}>
            <Grid gutter="default">
              {remainingArticles.map((article, i) => (
                <Grid.Item
                  hidden={i > 0 ? 'mobile' : null}
                  key={i}
                  width={{ d: 1 / 3 }}
                >
                  <Surround bordered="mobile" padded="mobile">
                    <Card
                      inverse
                      imageIcon="play"
                      typeConfig={{
                        title: {
                          size: ['heading7', 'heading6'],
                          weight: 'medium',
                          themed: true
                        }
                      }}
                      headerComponents={() => {
                        if (!article.category) return null
                        return <Tag background="black">{article.category}</Tag>
                      }}
                      {...{
                        ...article,
                        description: '',
                        sizes: [
                          '(min-width: 1420px) 318px',
                          '(min-width: 960px) calc(25vw - 32px - 80px)',
                          'calc((100vw - 80px) * 0.5)'
                        ],
                        width: 318
                      }}
                      imageRatio={imageRatio}
                    />
                  </Surround>
                </Grid.Item>
              ))}
            </Grid>
          </Column>
          <Column fixedWidth>
            <Advert {...advertProps} pageData={pageData} />
          </Column>
        </Container>
      </Container>
    </div>
  )
}

VideoGrid.propTypes = {
  articles: array,
  advertProps: object,
  title: string,
  ctaUrl: string,
  pageData: object
}

export default VideoGrid
